import { ReactNode } from 'react';

import { Tooltip } from 'antd';

interface TooltipAccessWrapperProps {
  children: ReactNode;
  hasAccessToFilter: boolean;
  message: string;
}

const TooltipAccessWrapper = ({
  children,
  hasAccessToFilter,
  message
}: TooltipAccessWrapperProps) => {
  if (hasAccessToFilter) {
    return <>{children}</>;
  }

  return (
    <Tooltip title={message} placement="bottom" trigger={['hover']}>
      {children}
    </Tooltip>
  );
};

export default TooltipAccessWrapper;
